import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../stili/Home.css";
import NavbarHome from "./NavbarHome";
import foto2015 from "../assets/img/foto_2015.jpeg";
import logoDx from "../assets/img/logo_dx.jpg";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8080").replace(/\/$/, "");

export default function Home() {
  const [notizie, setNotizie] = useState([]);
  const [eventi, setEventi] = useState([]);
  const [gareBacheca, setGareBacheca] = useState([]);
  const [risultatiBacheca, setRisultatiBacheca] = useState([]);
  const [messaggi, setMessaggi] = useState([]);

  const aggiungiMessaggio = (msg) => {
    setMessaggi((prev) => (prev.includes(msg) ? prev : [...prev, msg]));
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString("it-IT");
  };

  const contaFrequenza = (array, campo) => {
    if (!Array.isArray(array) || array.length === 0) return [];

    const frequenze = {};

    array.forEach((item) => {
      const nome = item?.[campo];
      if (nome && String(nome).trim() !== "") {
        frequenze[nome] = (frequenze[nome] || 0) + 1;
      }
    });

    return Object.entries(frequenze);
  };

  const normalizeMultilineText = (text) => {
    if (!text || typeof text !== "string") return "-";

    return text
      .replace(/\\r\\n/g, "\n")
      .replace(/\\n/g, "\n")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n");
  };

  const renderMultilineText = (text) => {
    const normalized = normalizeMultilineText(text);

    return normalized.split("\n").map((line, index, array) => (
      <React.Fragment key={index}>
        {line === "" ? "\u00A0" : line}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const renderFrequenza = (items) => {
  if (!items || items.length === 0) {
    return <div className="frequenza-empty">-</div>;
  }

  return (
    <div className="frequenza-lista">
      {items.map(([nome, count], idx) => (
        <div key={`${nome}-${idx}`} className="frequenza-item">
          <span className="frequenza-nome">{nome}</span>
          <span className="frequenza-badge">({count})</span>
        </div>
      ))}
    </div>
  );
};

  useEffect(() => {
    fetch(`${API_URL}/api/public/notizie`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        const ordinati = [...(data || [])].sort(
          (a, b) => new Date(b.dataPubblicazione) - new Date(a.dataPubblicazione)
        );
        setNotizie(ordinati);
      })
      .catch(() => aggiungiMessaggio("Errore nel caricamento delle notizie."));

    fetch(`${API_URL}/api/eventi/public`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        const ordinati = [...(data || [])].sort(
          (a, b) => new Date(a.dataEvento) - new Date(b.dataEvento)
        );
        setEventi(ordinati);
      })
      .catch(() => aggiungiMessaggio("Errore nel caricamento degli eventi."));

    fetch(`${API_URL}/api/public/eventogara/bacheca`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        const gare = (data || [])
          .flatMap((evento) => evento.gare || [])
          .sort((a, b) => (a.categoria || "").localeCompare(b.categoria || ""))
          .map((g) => ({
            ...g,
            oraGara: g.oraGara ? String(g.oraGara).slice(0, 5) : "",
          }));

        setGareBacheca(gare);
      })
      .catch(() => aggiungiMessaggio("Non ci sono elementi caricati in bacheca gare."));

    fetch(`${API_URL}/api/public/risultati-gara/bacheca`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        const risultati = [...(data?.content || [])].sort((a, b) =>
          (a.categoria || "").localeCompare(b.categoria || "")
        );
        setRisultatiBacheca(risultati);
      })
      .catch(() => aggiungiMessaggio("Nessun risultato disponibile in bacheca."));
  }, []);

  return (
    <>
      <Helmet>
        <title>Monterotondo Calcio</title>
      </Helmet>

      <div className="home-page" translate="no">
        <NavbarHome />

        <main className="home-shell">
          {messaggi.length > 0 && (
            <section className="home-alerts">
              {messaggi.map((m, idx) => (
                <div key={idx} className="home-alert-card">
                  {m}
                </div>
              ))}
            </section>
          )}

          <header className="home-hero">
            <div className="home-hero-content glass-card">
              <h1>Benvenuto nella nostra Società Sportiva</h1>
              <p>
                Notizie, eventi, programma gare e risultati sempre disponibili in un’unica pagina.
              </p>
            </div>
          </header>

          <section className="home-cover-section">
            <div className="glass-card home-image-card">
              <div className="immagine-fissa">
                <img src={foto2015} alt="Immagine storica Monterotondo 1935" />
              </div>
            </div>
          </section>

          <section className="home-section">
            <div className="glass-card section-card">
              <div className="section-header">
                <h2>Programma Gare in Bacheca</h2>
              </div>

              {gareBacheca.length === 0 ? (
                <p className="section-empty">Nessuna gara pubblicata al momento.</p>
              ) : (
                <div className="table-wrapper">
                  <table className="home-table">
                    <thead>
                      <tr>
                        <th>Categoria</th>
                        <th>Gara in Programma</th>
                        <th>Data</th>
                        <th>Ora</th>
                        <th>Indirizzo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gareBacheca.map((g, index) => (
                        <tr key={`${g.id || "gara"}-${index}`} className="bacheca-gara-row">
                          <td className="nome-squadra" data-label="Categoria">
                            {g.categoria || "-"}
                          </td>

                          <td data-label="Gara" className="gara-mobile-cell">
                            <div className="gara-desktop-inline">
                              {g.luogo === "CASA" ? (
                                <>
                                  <span className="nome-squadra">MONTEROTONDO 1935</span>
                                  {" - "}
                                  {g.avversario || "-"}
                                </>
                              ) : (
                                <>
                                  {g.avversario || "-"}
                                  {" - "}
                                  <span className="nome-squadra">MONTEROTONDO 1935</span>
                                </>
                              )}
                            </div>

                            {g.luogo === "CASA" ? (
                              <div className="gara-mobile-vertical">
                                <div className="gara-squadra nome-squadra">MONTEROTONDO 1935</div>
                                <div className="gara-vs">vs</div>
                                <div className="gara-squadra">{g.avversario || "-"}</div>
                              </div>
                            ) : (
                              <div className="gara-mobile-vertical">
                                <div className="gara-squadra">{g.avversario || "-"}</div>
                                <div className="gara-vs">vs</div>
                                <div className="gara-squadra nome-squadra">MONTEROTONDO 1935</div>
                              </div>
                            )}
                          </td>

                          <td data-label="Data">{formatDate(g.dataGara)}</td>
                          <td data-label="Ora">{g.oraGara || "-"}</td>
                          <td data-label="Indirizzo">{g.indirizzo || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </section>

          <section className="home-section">
            <div className="glass-card section-card">
              <div className="section-header">
                <h2>Risultati in Bacheca</h2>
              </div>

              {risultatiBacheca.length === 0 ? (
                <p className="section-empty">Nessun risultato disponibile.</p>
              ) : (
                <div className="table-wrapper">
                  <table className="home-table">
                    <thead>
                      <tr>
                        <th>Categoria</th>
                        <th>Gara</th>
                        <th>Risultato</th>
                        <th>Marcatori</th>
                        <th>Assistman</th>
                      </tr>
                    </thead>
                    <tbody>
                      {risultatiBacheca.map((r, i) => {
                        const marcatoriFreq = contaFrequenza(r.reti, "marcatore");
                        const assistFreq = contaFrequenza(r.reti, "assist");

                        return (
                          <tr key={`${r.id || "risultato"}-${i}`} className="bacheca-gara-row">
                            <td className="nome-squadra" data-label="Categoria">
                              {r.categoria || "-"}
                            </td>

                            <td data-label="Gara" className="gara-mobile-cell">
                              <div className="gara-desktop-inline">
                                {r.luogo === "CASA" ? (
                                  <>
                                    <span className="nome-squadra">MONTEROTONDO 1935</span>
                                    {" - "}
                                    {r.avversario || "-"}
                                  </>
                                ) : (
                                  <>
                                    {r.avversario || "-"}
                                    {" - "}
                                    <span className="nome-squadra">MONTEROTONDO 1935</span>
                                  </>
                                )}
                              </div>

                              {r.luogo === "CASA" ? (
                                <div className="gara-mobile-vertical">
                                  <div className="gara-squadra nome-squadra">MONTEROTONDO 1935</div>
                                  <div className="gara-vs">vs</div>
                                  <div className="gara-squadra">{r.avversario || "-"}</div>
                                </div>
                              ) : (
                                <div className="gara-mobile-vertical">
                                  <div className="gara-squadra">{r.avversario || "-"}</div>
                                  <div className="gara-vs">vs</div>
                                  <div className="gara-squadra nome-squadra">MONTEROTONDO 1935</div>
                                </div>
                              )}
                            </td>

                            <td data-label="Risultato">{r.risultatoTestuale || "-"}</td>

                            <td data-label="Marcatori" className="colonna-frequenza">
                              {renderFrequenza(marcatoriFreq)}
                            </td>

                            <td data-label="Assistman" className="colonna-frequenza">
                              {renderFrequenza(assistFreq)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </section>

          <section className="home-section">
            <div className="glass-card section-card">
              <div className="section-header">
                <h2>Ultime Notizie</h2>
              </div>

              {notizie.length > 0 ? (
                <div className="news-list">
                  {notizie.map((item, index) => (
                    <article key={`${item.id}-${index}`} className="news-card">
                      <div className="news-image">
                        <img src={logoDx} alt="Logo Monterotondo" />
                      </div>

                      <div className="news-content">
                        <h3>{item.titolo}</h3>
                        <p>
                          <strong>Autore:</strong> {item.autore || "-"}
                        </p>
                        <p>
                          <strong>Data:</strong> {formatDate(item.dataPubblicazione)}
                        </p>

                        <div className="content-description-block">
                          <strong>Contenuto:</strong>
                          <div className="content-description-text">
                            {renderMultilineText(item.contenuto)}
                          </div>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              ) : (
                <p className="section-empty">Nessuna notizia disponibile.</p>
              )}
            </div>
          </section>

          <section className="home-section">
            <div className="glass-card section-card">
              <div className="section-header">
                <h2>Eventi in Programma</h2>
              </div>

              {eventi.length > 0 ? (
                <div className="event-list">
                  {eventi.map((item, index) => (
                    <article key={`${item.id}-${index}`} className="event-card">
                      <h3>{item.titolo}</h3>

                      <div className="content-description-block">
                        <strong>Descrizione:</strong>
                        <div className="content-description-text">
                          {renderMultilineText(item.descrizione)}
                        </div>
                      </div>

                      <p>
                        <strong>Data:</strong> {formatDate(item.dataEvento)}
                      </p>
                      <p>
                        <strong>Luogo:</strong> {item.luogo || "-"}
                      </p>
                    </article>
                  ))}
                </div>
              ) : (
                <p className="section-empty">Nessun evento in programma.</p>
              )}
            </div>
          </section>
        </main>
      </div>
    </>
  );
}